import { useDetectGPU } from "@react-three/drei";

/**
 * Shared GPU-tier reader. Thin wrapper over drei's useDetectGPU so the
 * postprocessing gate reads tier from one place. Safe to call
 * outside <Canvas>.
 */
export function useGpuTier(): ReturnType<typeof useDetectGPU> {
  return useDetectGPU();
}
